import React from 'react';
import { cn } from '../../lib/utils';
import { BookingStatus } from '../../types';

export const StatusBadge = ({ status }: { status: BookingStatus }) => {
  const configs = {
    'Menunggu': 'bg-amber-50 text-amber-600 border-amber-100',
    'Proses': 'bg-blue-50 text-blue-600 border-blue-100',
    'Selesai': 'bg-emerald-50 text-emerald-600 border-emerald-100',
    'Batal': 'bg-slate-50 text-slate-400 border-slate-200',
  };
  return (
    <span className={cn("px-3 py-1 rounded-full text-[10px] font-bold border", configs[status])}>
      {status}
    </span>
  );
};
